import { render } from "./PainelLayout.vue?vue&type=template&id=9f9c92c4&scoped=true"
import script from "./PainelLayout.vue?vue&type=script&lang=js"
export * from "./PainelLayout.vue?vue&type=script&lang=js"

import "./PainelLayout.vue?vue&type=style&index=0&id=9f9c92c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9c92c4"]])

export default __exports__